// extracted by mini-css-extract-plugin
export default {"warningModalBody":"WarningModal_warningModalBody__R3AB8"};